export * from './createAction';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lifesize/typescript-react-redux-utils/es5-module/index.js
// module id = 161
// module chunks = 0